import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "@/pages/home/components/Hero";
import HotBoard from "@/pages/home/components/HotBoard";
import CaseGallery from "@/pages/home/components/CaseGallery";
import MethodSection from "@/pages/home/components/MethodSection";
import RumorVsFact from "@/pages/home/components/RumorVsFact";
import Timeline from "@/pages/home/components/Timeline";
import SubmitCTA from "@/pages/home/components/SubmitCTA";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <HotBoard />
        <CaseGallery />
        <MethodSection />
        <RumorVsFact />
        <Timeline />
        <SubmitCTA />
      </main>
      <Footer />
    </div>
  );
}